/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */

// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
'use es6';

import { memo } from 'react';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getNavigateToTicketRecord } from '../../tickets/constants/Events';
import { jsx as _jsx } from "react/jsx-runtime";
export const withTicketNavigationTracking = WrappedComponent => /*#__PURE__*/memo(props => /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
  onTicketLinkClick: () => trackEvent(getNavigateToTicketRecord(false))
}, props)));